// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// eslint-disable-next-line no-console
// console.log('.....', process.env.REACT_APP_ENVIRONMENT);

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? {
        apiKey: 'AIzaSyB-8i3RAZUtWjJlVoZRfzwo3iQoytGQrY0',
        authDomain: 'delpo-qc-dev.firebaseapp.com',
        projectId: 'delpo-qc-dev',
        storageBucket: 'delpo-qc-dev.appspot.com',
        messagingSenderId: '175359953971',
        appId: '1:175359953971:web:e2b8f9db30813c66a76746',
        measurementId: 'G-3C4BPM35LT'
      }
    : {
        apiKey: 'AIzaSyC7nPTl5HlKDu9JwGaRKXX2O0DKz4Kd5jk',
        authDomain: 'delpo-qc.firebaseapp.com',
        projectId: 'delpo-qc',
        storageBucket: 'delpo-qc.appspot.com',
        messagingSenderId: '787049400215',
        appId: '1:787049400215:web:795508c91514a99a33e6d2',
        measurementId: 'G-N8VRZDX531'
      };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
